import { Component, OnInit } from '@angular/core';
import * as appConstants from '../../assets/json/applicationConstants.json';
import { environment as env } from 'src/environments/environment';

@Component({
  selector: 'app-wellness',
  templateUrl: './wellness.component.html',
  styleUrls: ['./wellness.component.css']
})
export class WellnessComponent implements OnInit {
  brandData = appConstants?.commonAppConstants?.brandData;
  wellnessUrl=env.ahyushUrl;
  constructor() { }

  ngOnInit(): void {
  }

}
